import { z } from 'zod';
import { dateField } from '@shared/schemas';
import { notificationMetadataSchema, INotificationMetadata } from './INotificationMetadata';
import { NotificationTypes } from './NotificationTypes.enum';

// Schemas (source of truth) — pure validation, no transforms
export const notificationSchema = z.object({
	_id: z.string(),
	projectId: z.string(),
	username: z.string(),
	type: z.enum(NotificationTypes),
	isVisible: z.boolean(),
	isViewed: z.boolean(),
	metadata: notificationMetadataSchema.optional(),
	createdAt: dateField,
});

export type INotification = z.infer<typeof notificationSchema>;
